const mixinValidations = {
  methods: {
    async validationInput(reference, indexnum) {
      let elementsArray = document.getElementsByClassName(
        'required-' + reference
      );

      for (let i = 0; i < elementsArray.length; i++) {
        if (i == indexnum) {
          let inputsArray = elementsArray[i].getElementsByTagName('input');
          for (let index of inputsArray) {
            index.focus();
            index.classList.add('custom-has-error');
            this.removeHasError(index);
            return false;
          }
        }
      }

      return true;
    },

    async validationInputsRequired(reference) {
      let elementsArray = document.getElementsByClassName(
        'required-' + reference
      );

      for (let key of elementsArray) {
        let inputsArray = key.getElementsByTagName('input');
        for (let index of inputsArray) {
          if (index.value.length == 0) {
            index.focus();
            index.classList.add('custom-has-error');
            this.removeHasError(index);
            return false;
          }
        }
      }

      return true;
    },

    async validationInputsZeroRequired(reference) {
      let elementsArray = document.getElementsByClassName(
        'required-' + reference
      );

      for (let key of elementsArray) {
        let inputsArray = key.getElementsByTagName('input');
        for (let index of inputsArray) {
          index.focus();
          index.classList.add('custom-has-error');
          this.removeHasError(index);
          return false;
        }
      }

      return true;
    },

    async removeHasError(index) {
      if (index.classList.contains('el-input__inner')) {
        setTimeout(() => {
          index.classList.remove('custom-has-error');
        }, 3000);
      }

      return true;
    },

    getError(fieldName) {
      if (this.$refs[fieldName]) {
        let requireds = this.$refs[fieldName].$el.getElementsByTagName('input');
        for (let item of requireds) {
          item.focus();
        }
      }
      return this.errors.first(fieldName);
    },
  },
};

export default mixinValidations;
